import { Box, Chip, Avatar, Stack } from "@mui/material";
import { assertThumbnailUrl, LoadState } from "../../../redux/common";
import { getItemOptionColor } from "../../routine/main/RoutineItemList";
import { RoutineItemInfo } from "../../../redux/routine/routineItemSlice";
import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { routineRecordChange, RoutineRecordChangeRequest, selectRoutineRecordChange } from "../../../redux/routine/routineRecordChangeSlice";
import { RoutineRecordInfo } from "../../../redux/routine/routineRecordSlice";
import { RoutineItemOptionInfo } from "../../../redux/routine/routineItemOptionSlice";

interface RoutineItemOptionsCellProps {
    eventDate: string;
    classroomId: string;
    studentId: string;
    item: RoutineItemInfo;
    routineItemOptions: RoutineItemOptionInfo[];
    routineRecords: RoutineRecordInfo[];
}

const RoutineItemOptionsCell = ({
    eventDate,
    classroomId,
    studentId,
    item,
    routineItemOptions,
    routineRecords
}: RoutineItemOptionsCellProps) => {
    const dispatch = useAppDispatch();
    const recordChange = useSelector(selectRoutineRecordChange);

    const foundRequest = recordChange.requests.find(r =>
        r.request.classroomId === classroomId &&
        r.request.studentId === studentId &&
        r.request.eventDate === eventDate &&
        r.request.routineId === item.routineId &&
        r.request.routineItemId === item.id
    );
    const changing = foundRequest?.state.state === LoadState.Loading;

    const request: RoutineRecordChangeRequest = {
        classroomId: classroomId,
        studentId: studentId,
        eventDate: eventDate,
        routineId: item.routineId,
        routineItemId: item.id,
    };

    const handleOptionClick = (optionId?: string) => {
        console.log(`Option clicked: itemId=${item.id}, optionId=${optionId}`);
        dispatch(routineRecordChange(
            {...request, routineItemOptionId: optionId}
        ));
    };

    let hasFilled = false;
    return (
        <Stack
            direction="row"
            // spacing={1}
            flexWrap="wrap"
            useFlexGap={false}
        >
            {routineItemOptions
                ?.filter(option => option.routineItemId === item.id)
                .sort((a, b) => (a.order || 99) - (b.order || 99))
                .map(option => {
                    const isFilled = !!routineRecords?.some(
                        record =>
                            `${record.studentId}` === `${studentId}` &&
                            `${record.routineItemId}` === `${item.id}` &&
                            `${record.routineItemOptionId}` === `${option.id}`
                    );
                    if (isFilled) hasFilled = true;
                    return (
                        <Box key={option.id} sx={{ mx: "2px", my: 0, width: "145px" }}>
                            <Chip
                                sx={{ 
                                    width: "100%",
                                    color: (theme) => isFilled ? getItemOptionColor(theme, option.color).contrastText : getItemOptionColor(theme, option.color).main,
                                    border: (theme) => isFilled ? `1px solid ${getItemOptionColor(theme, option.color).contrastText}` : `1px solid ${getItemOptionColor(theme, option.color).main}`,
                                    backgroundColor: (theme) => isFilled ? getItemOptionColor(theme, option.color).main : getItemOptionColor(theme, option.color).contrastText,
                                }}
                                avatar={<Avatar alt={option.name} src={assertThumbnailUrl(option.url)} />}
                                label={
                                    <Box sx={{ width: "85px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {option.name}
                                    </Box>
                                }
                                variant={isFilled ? "filled" : "outlined"}
                                onClick={() => {
                                    if (isFilled) return;
                                    handleOptionClick(option.id);
                                }}
                                disabled={changing}
                            />
                        </Box>
                    );
                })
            }
            {(() => {
                return (
                    <Box key={"not-informed"} sx={{ mx: "2px", my: 0, width: "145px" }}>
                        <Chip
                            sx={{ width: "100%" }}
                            avatar={<Avatar alt="Não informado" src="/static/images/not-informed.jpg" />}
                            label={
                                <Box sx={{ width: "103px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    Não informado
                                </Box>
                            }
                            color="primary"
                            variant={hasFilled ? "outlined" : "filled"}
                            onClick={() => {
                                if (hasFilled) {
                                    handleOptionClick(undefined);
                                }
                            }}
                            disabled={changing}
                        />
                    </Box>
                );
            })()}
        </Stack>
    );
};

export default RoutineItemOptionsCell;
